// BidZuu API Configuration
import axios from "axios";
import { API_URL } from "./constants";

// Axios instance - using JWT tokens in headers, not cookies
// withCredentials: false to avoid CORS issues with cross-origin requests
const api = axios.create({
  baseURL: API_URL,
  withCredentials: false
});

// Add auth header interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
